module.exports = __webpack_public_path__ + "img/17.3ba8a74a.png";